import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Radio } from '@fiverr-private/fit';
import { Radio as PentaRadio } from '@fiverr-private/forms';
import { usePricingData } from '@fiverr-private/price_upfront_components';
import { Container } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Typography } from '@fiverr-private/typography';
import { formatFilterRowPrice, formatPrice } from './PriceBuckets.utils';

import './PriceBuckets.styles.scss';

export interface PriceBucket {
    id: string;
    min: number;
    max: number;
}

interface PriceBucketProps {
    budgetValue: string | { min: number; max: number };
    priceBucketOptions: PriceBucket[];
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    currency: { code: string };
    usePillButton?: boolean;
}

export const PriceBuckets: React.FC<PriceBucketProps> = ({
    budgetValue,
    priceBucketOptions = [],
    onChange,
    currency,
    usePillButton = false,
}) => {
    const { isPriceUpfrontEnabled } = usePricingData();

    if (usePillButton) {
        return (
            <Box display="flex" direction="column">
                {priceBucketOptions.map((priceBucket, index) => (
                    <Box key={index} height="40px" display="flex" alignItems="center" marginBottom="1">
                        <PentaRadio
                            value={priceBucket.id}
                            name={priceBucket.id}
                            checked={budgetValue === priceBucket.id}
                            onChange={onChange}
                            disableOutline
                        >
                            {formatFilterRowPrice(priceBucket, index, currency)}
                        </PentaRadio>
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <div className="price-buckets-wrapper radio-list flex flex-col">
            {isPriceUpfrontEnabled && (
                <Container paddingX="3">
                    <Typography size="b_sm" color="grey_900">
                        <I18n k="search_perseus.filters.global.budget.price_upfront" />
                    </Typography>
                </Container>
            )}
            {priceBucketOptions.map((priceBucket, index) => (
                <div key={index} className="radio-item-wrapper">
                    <Radio
                        value={priceBucket.id}
                        name={priceBucket.id}
                        checked={budgetValue === priceBucket.id}
                        className={classnames('radio-item', { selected: budgetValue === priceBucket.id })}
                        onChange={onChange}
                    >
                        <div className="inner-radio">{formatPrice(priceBucket, index, currency)}</div>
                    </Radio>
                </div>
            ))}
        </div>
    );
};
